module.exports = __webpack_public_path__ + "static/media/phone-footer.83bee7d1.svg";